module.exports = __webpack_public_path__ + "img/A1.a7fdae3f.jpg";